import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Alert } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import { IoMdAdd } from "react-icons/io";
import { AiOutlineMinus } from "react-icons/ai";
import { apiCall } from '../config';

const Cart = (props) => {
  const [cartItems, setCartItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [appStatus, setAppStatus] = useState('ON');

  useEffect(() => {
    async function fetchData() {      
      setLoading(true);
      try {
        const cartItemsRes = await apiCall('/get/cart', {
          body: {
            userId: localStorage.getItem('userID'),
            location: localStorage.getItem('userCity')
          }
        });

        setAppStatus(cartItemsRes.app_status); 
        let storedCart = cartItemsRes.body || [];
        props.setCartNumber(storedCart.reduce((sum, item) => sum + item.quantity, 0));
        storedCart = storedCart.filter(cart => cart.stock === "in-stock");
        setCartItems(storedCart);

        const calculatedTotal = storedCart.reduce((acc, item) => acc + item.amount * item.quantity, 0);
        setTotal(calculatedTotal);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching cart data:", error);
        setLoading(false);
      }

    }
    fetchData();
  }, [props]);

  const updateQuantity = async (index, quantity) => {
    if (quantity < 1) return;

    const item = cartItems[index];    

    try {
      await apiCall('/put/cart', {
        body: {
          quantity, 
          amount: item.amount, 
          user_id: localStorage.getItem('userID'), 
          product_quantity: item.price_quantity,
          itemId: item.item_id
        }
      });

      const updatedCartItems = [...cartItems];
      updatedCartItems[index].quantity = quantity;
      setCartItems(updatedCartItems);
      props.setCartNumber(updatedCartItems.reduce((sum, item) => sum + item.quantity, 0));

      const newTotal = updatedCartItems.reduce((acc, item) => acc + item.amount * item.quantity, 0);
      setTotal(newTotal);
    } catch (error) {
      console.error("Error updating cart item quantity:", error);
    }
  };

  const removeItem = async (index) => {
    const item = cartItems[index];

    try {
      await apiCall('/delete/cart', {
        body: {
          user_id: localStorage.getItem('userID'),
          id: item.item_id
        }
      });

      const updatedCartItems = cartItems.filter((_, i) => i !== index);
      setCartItems(updatedCartItems);
      props.setCartNumber(updatedCartItems.reduce((sum, item) => sum + item.quantity, 0));

      const newTotal = updatedCartItems.reduce((acc, item) => acc + item.amount * item.quantity, 0);
      setTotal(newTotal);
    } catch (error) {
      console.error("Error removing cart item:", error);
    }
  };

  const handleCheckout = () => {
    if (total > 200) {
      props.setActivePage('checkout');
    } else {
      setShowAlert(true);
    }
  };

  return (
    !isLoading ? (<Container>
      <h3 className="mb-4 text-center content-primary">Your Cart</h3>
      {showAlert && (
        <Alert variant="danger" onClose={() => setShowAlert(false)} dismissible>
          The total must be greater than ₹200 to proceed to checkout.
        </Alert>
      )}
      {cartItems.length > 0 ? (
        <>
          <Row>
            {cartItems.map((item, index) => (
              <Col xs={12} key={index} className="mb-4">
                <Card className="cart-card shadow-sm">
                  <Row>
                    <Col xs={5} md={5}>
                      <Card.Img variant="left" src={item.image_url} alt={item.name} className="cart-card-image" />
                    </Col>
                    <Col xs={7} md={7}>
                      <Card.Body className='border-0'>
                        <Card.Title>{item.name}</Card.Title>
                        <Card.Text className='fs-12'>
                          <strong>Price:</strong> ₹{item.amount} ({item.price_quantity})
                        </Card.Text>
                        <Card.Text>
                          <strong>Total:</strong> ₹{(item.amount * item.quantity).toFixed(2)}
                        </Card.Text>
                        <div className="d-flex align-items-start">
                          <Form.Control
                            type="number"
                            min="1"
                            value={item.quantity}
                            onChange={(e) => updateQuantity(index, Number(e.target.value))}
                            className="text-center"
                            style={{ width: '50px' }}
                          />
                          <span
                            className="addremove m-2"
                            onClick={() => updateQuantity(index, item.quantity - 1)}
                          >
                            <AiOutlineMinus />
                          </span>
                          <span
                            className="addremove m-2"
                            onClick={() => updateQuantity(index, item.quantity + 1)}
                          >
                            <IoMdAdd />
                          </span>
                          <span
                            className="m-2 remove-btn"
                            onClick={() => removeItem(index)}
                          >
                            <FaTrash />
                          </span>
                        </div>
                      </Card.Body>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))}
          </Row>
          <Row>
            <Col className="text-right">
              <h4>
                <strong>Total: </strong>₹{total.toFixed(2)}
              </h4>
              {
                appStatus === 'OFF' ? <div className="timings-banner-off off-bg footer-banner text-center text-white my-3">
                  <p>We are not currently accepting any orders!</p></div> : 
                <Button variant="success" className="mt-3 w-100" onClick={handleCheckout}>
                  Proceed to Checkout
                </Button>
              }
            </Col>
          </Row>
        </>
      ) : (
        <Alert variant="danger" className="text-center">
          Your cart is empty.
        </Alert>
      )}
    </Container>) : (<div className='loader-container'><div className="loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div></div>)
  );
};

export default Cart;
